import React from 'react'
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Button from "@mui/material/Button";
import { v4 as uuidv4 } from "uuid";


const CloudConsultationFaq = () => {
    const webDevelopmentFAQs = [
        {
          id: uuidv4(),
          question:
            "Why should my business consider cloud consultation services?",
          answer:
            "Cloud consultation services help businesses leverage the full potential of cloud technology. Our experts provide strategic guidance tailored to your specific needs, ensuring optimal use of cloud solutions for enhanced scalability, efficiency, and overall digital transformation.",
        },
        {
          id: uuidv4(),
          question:
            "What does the cloud consultation process involve?",
          answer:
            "The cloud consultation process at Flint Infotech is collaborative and comprehensive. We analyze your business requirements, current IT infrastructure, and future goals. Our experts then provide insights on suitable cloud platforms, migration strategies, and ongoing optimization plans.",
        },
        {
          id: uuidv4(),
          question:
            " How can Flint Infotech help in choosing the right cloud platform for my business?",
          answer:
            "Our experienced consultants assess your business needs and recommend the most suitable cloud platforms, such as AWS, Azure, or Google Cloud. We consider factors like scalability, security, and cost-effectiveness to ensure the chosen platform aligns with your specific goals.",
        },
        {
          id: uuidv4(),
          question:
            " Is cloud consultation only for large enterprises, or is it beneficial for small businesses too?",
          answer:
            "Cloud consultation services are beneficial for businesses of all sizes. We tailor our consultation to meet the unique needs and budget constraints of small and medium-sized enterprises, enabling them to harness the advantages of cloud technology.",
        },
        {
          id: uuidv4(),
          question:
            "What long-term benefits can my business expect from cloud consultation with Flint Infotech?",
          answer:
            "Our cloud consultation services provide long-term benefits by establishing a solid foundation for digital transformation. Expect enhanced efficiency, scalability, and security, with ongoing support for adapting to evolving business needs. We ensure your cloud strategy aligns with industry best practices, ensuring sustained success in the dynamic digital landscape.",
        },
      ];
      return (
        <div className="px-5 sm:px-60 mt-10" id="faq">
          <p className="text-center font-notosans text-2xl sm:text-4xl font-bold m-10 text-[#333e49]">
            Frequently Asked Questions
          </p>
          {webDevelopmentFAQs.map((item) => (
            <Accordion key={item.id}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
                className="font-notosans font-bold"
              >
                {item.question}
              </AccordionSummary>
              <AccordionDetails className="font-notosans">
                {item.answer}
              </AccordionDetails>
            </Accordion>
          ))}
        </div>
      );
}

export default CloudConsultationFaq